import React, {memo} from "react";
import { Link } from "react-router-dom";
import cx from "classnames";
import useTitle from "../../../../modules/hooks/useTitle";

export const SUBS = [
  { url: 0, code: "mdcn", label: "약품" },
  { url: 2, code: "warningMdcn", label: "주의약품" },
  { url: 1, code: "food", label: "식품" },
  { url: 9, code: "etc", label: "기타" },
];

export const SubMenu = memo(props => {
  const { code, allergyType, setAllergyType, setSearchMode } = props;

  const setTitle = useTitle("자가건강관리_알레르기_약품");

  const moveSubMenu = url => {
    setAllergyType(url);
    setSearchMode(0);

    setTitle(
      `자가건강관리_알레르기_${
        url === 0
          ? "약품"
          : url === 1
          ? "식품"
          : url === 2
          ? "주의약품"
          : "기타"
      }`
    );
  };
  return (
    <div className="top-roundtab-contain">
      <ul>
        {SUBS.map((m, i) => (
          <li style={{ width: "25%" }} key={i}>
            <a
              onClick={() => moveSubMenu(m.url)}
              className={cx({ on: allergyType === m.url })}>
              {m.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
});